
import { Component, Vue } from "vue-property-decorator";
import { Action, Getter, Mutation, State } from "vuex-class";

const namespace = "BookModule";

@Component({
  components: {
  },
})

export default class Book extends Vue{
  @Mutation('setDisplayingChapter', {namespace}) private setDisplayingChapter!: (value:number) => any;
  @State('displayingChapter', { namespace }) private displayingChapter!: number;

  private handleMenuClick(value:number){
    this.setDisplayingChapter(value);
  }

  private handlePreviousClick(){
    this.setDisplayingChapter(this.displayingChapter-1);
  }
};
